export default __webpack_public_path__ + "static/media/chuvaTrovoada.1eb3c7c2.svg";